import classnames from 'classnames';
import React, { useState } from 'react';
import { Heading } from '@mm/components';
import { OpenEmailSubsmissionModalParams } from '@mm/state/modules/modalsState/actions';
import { PrimaryButton } from '../../buttons/PrimaryButton/PrimaryButton';
import { ModalInstanceProps } from '../interfaces';
import { EmailInput } from '../InviteUserModal/EmailInput/EmailInput';
import { ModalBody, ModalFooter, ModalHeader } from '../modal-helpers';
import './EmailSubmissionModal.pcss';

type Props = ModalInstanceProps & OpenEmailSubsmissionModalParams;

export const EmailSubmissionModal = ({
  closeModal,
  onStepsComplete,
  onEmailChange,
  onClose,
  emailState: { isValid, email },
}: Props) => {
  const [localEmailState, setLocalEmailState] = useState({ email, isValid });
  return (
    <div className="email-submission-modal">
      <ModalHeader
        className="email-submission-modal__header"
        closeOverride={() => {
          onClose?.();
          closeModal();
        }}
      >
        <Heading
          className="email-submission-modal__heading"
          size={2}
          text="Where should we send your contacts?"
        />
      </ModalHeader>
      <ModalBody className="email-submission-modal__body">
        <div className="email-submission-modal__email-container">
          <span className="email-submission-modal__email-input-label">
            Your email
          </span>
          <EmailInput
            inputProps={{ value: localEmailState.email }}
            className="email-submission-modal__email-input"
            onChange={({ email, isValid }) => {
              onEmailChange({ email, isValid });
              setLocalEmailState({ email, isValid });
            }}
          />
        </div>
      </ModalBody>
      <ModalFooter className="email-submission-modal__footer">
        <div className="email-submission-modal__finish-container">
          <PrimaryButton
            onClick={() => {
              closeModal();
              onStepsComplete(localEmailState.email);
            }}
            disabled={!localEmailState.isValid}
            className={classnames('email-submission-modal__finish-button', {
              'email-submission-modal__finish-button--disabled':
                !localEmailState.isValid,
            })}
          >
            Finish
          </PrimaryButton>
        </div>
      </ModalFooter>
    </div>
  );
};
